import { Component, OnInit, inject } from '@angular/core';
import { idNameItem, JkBaseOption, jkLib, jkRestReturn } from 'jk-service';
import { AdvComModule, jkQueryComponent, JkgridwinComponent } from 'jk-advcom';
import { JackBaseComponentModule } from 'jk-service';
import { MaterialModule } from 'jk-service';
import { ColDef } from 'ag-grid-community';
import { ESunIntradayTickersQuery, StockService } from '../services/stock.service';

/*
查詢條件放這裡.供以後預設上一次條件用
*/
class FilterOption extends JkBaseOption { // ###
  dateA: string = jkLib.nowDate();
  dateB: string = jkLib.nowDate();
  kind: string = '';
  account: string = '';
  symbolList: string = '';
  session: string = 'REGULAR';
  shortTimeframe: string = '5';
  longTimeframe: string = '30';
  shortIntervalSeconds: number = 300;
  longIntervalSeconds: number = 1800;
  runImmediately: boolean = true;
  stockSymbolList: string = '';
  stockShortTimeframe: string = '5';
  stockLongTimeframe: string = '30';
  stockShortIntervalSeconds: number = 300;
  stockLongIntervalSeconds: number = 1800;
  stockRunImmediately: boolean = true;
  tickerType: string = 'EQUITY';
  tickerExchange: string = '';
  tickerMarket: string = '';
  tickerIndustry: string = '';
  tickerSession: string = 'REGULAR';
  tickerProduct: string = '';
  tickerContractType: string = '';
  tickerIsNormal: string = '';
  tickerIsAttention: string = '';
  tickerIsDisposition: string = '';
  tickerIsHalted: string = '';
}


@Component({
  selector: 'app-stkpq19',
  standalone: true,
  imports: [JackBaseComponentModule, MaterialModule, AdvComModule],
  templateUrl: './stkpq19.component.html',
  styleUrl: './stkpq19.component.css'
})
export class Stkpq19Component extends jkQueryComponent implements OnInit {
  stockSrv = inject(StockService);
  override _programId = 'stkpq19'; // ### 玉山證API查詢(stkpq19)
  filterOpt: FilterOption = new FilterOption(this.programId);//###
  sessionList: idNameItem[] = [
    { id: 'REGULAR', name: '一般盤' },
    { id: 'AFTERHOURS', name: '盤後盤' },
  ];
  timeframeList: idNameItem[] = [
    { id: '1', name: '1分' },
    { id: '5', name: '5分' },
    { id: '10', name: '10分' },
    { id: '15', name: '15分' },
    { id: '30', name: '30分' },
    { id: '60', name: '60分' },
  ];
  tickerTypeList: idNameItem[] = [
    { id: 'EQUITY', name: '股票' },
    { id: 'INDEX', name: '指數' },
    { id: 'WARRANT', name: '權證' },
    { id: 'ODDLOT', name: '零股' },
    { id: 'FUTURE', name: '期貨' },
  ];
  tickerExchangeList: idNameItem[] = [
    { id: '', name: '全部' },
    { id: 'TWSE', name: 'TWSE' },
    { id: 'TPEx', name: 'TPEx' },
  ];
  tickerFutureExchangeList: idNameItem[] = [
    { id: 'TAIFEX', name: 'TAIFEX' },
  ];
  tickerMarketList: idNameItem[] = [
    { id: '', name: '全部' },
    { id: 'TSE', name: '上市 TSE' },
    { id: 'OTC', name: '上櫃 OTC' },
    { id: 'ESB', name: '興櫃 ESB' },
    { id: 'TIB', name: '創新板 TIB' },
    { id: 'PSB', name: '戰略新板 PSB' },
  ];
  tickerBoolList: idNameItem[] = [
    { id: '', name: '全部' },
    { id: 'true', name: '是' },
    { id: 'false', name: '否' },
  ];
  tickerContractTypeList: idNameItem[] = [
    { id: '', name: '全部' },
    { id: 'I', name: '指數類 I' },
    { id: 'R', name: '利率類 R' },
    { id: 'B', name: '債券類 B' },
    { id: 'C', name: '商品類 C' },
    { id: 'S', name: '股票類 S' },
    { id: 'E', name: '匯率類 E' },
  ];
  tickerColumnDefs: ColDef[] = [
    { field: 'symbol', headerName: '代號', width: 110, cellDataType: 'text' },
    { field: 'name', headerName: '名稱', width: 180, cellDataType: 'text' },
    { field: 'date', headerName: '日期', width: 110, cellDataType: 'text' },
    { field: 'type', headerName: '類型', width: 100, cellDataType: 'text' },
    { field: 'exchange', headerName: '交易所', width: 100, cellDataType: 'text' },
    { field: 'market', headerName: '市場別', width: 100, cellDataType: 'text' },
    { field: 'industry', headerName: '產業', width: 140, cellDataType: 'text' },
    { field: 'session', headerName: '交易時段', width: 110, cellDataType: 'text' },
    { field: 'contractType', headerName: '契約類型', width: 110, cellDataType: 'text' },
    { field: 'referencePrice', headerName: '參考價', width: 100, cellDataType: 'number' },
    { field: 'startDate', headerName: '開始日', width: 110, cellDataType: 'text' },
    { field: 'endDate', headerName: '結束日', width: 110, cellDataType: 'text' },
    { field: 'settlementDate', headerName: '結算日', width: 110, cellDataType: 'text' },
    { field: 'isNormal', headerName: '正常', width: 90, cellDataType: 'boolean' },
    { field: 'isAttention', headerName: '處置注意', width: 110, cellDataType: 'boolean' },
    { field: 'isDisposition', headerName: '處置', width: 90, cellDataType: 'boolean' },
    { field: 'isHalted', headerName: '暫停交易', width: 110, cellDataType: 'boolean' },
  ];
  configFileList: idNameItem[] = [
    { id: 'esun-monitor.toml', name: 'esun-monitor.toml' },
    { id: 'esun-universe.toml', name: 'esun-universe.toml' },
  ];
  selectedConfigFile: string = 'esun-monitor.toml';
  configText: string = '';
  configFilePath: string = '';
  scheduleStatus: any = {};
  scheduleStatusText: string = '尚未查詢';
  stockScheduleStatus: any = {};
  stockScheduleStatusText: string = '尚未查詢';
  tickerGrid?: JkgridwinComponent;
  tickerList: any[] = [];
  tickerStatusText: string = '尚未查詢';
  apiMessage: string = '';
  isBusy: boolean = false;
  constructor() {
    super();
    this.setFormOpt2(); //###
    this.applyDefaultTimeframes();
  }

  private applyDefaultTimeframes(): void {
    const validTimeframes = this.timeframeList.map((item) => item.id);
    if (!validTimeframes.includes(this.filterOpt.shortTimeframe)) {
      this.filterOpt.shortTimeframe = '5';
    }
    if (!validTimeframes.includes(this.filterOpt.longTimeframe)) {
      this.filterOpt.longTimeframe = '30';
    }
    if (!validTimeframes.includes(this.filterOpt.stockShortTimeframe)) {
      this.filterOpt.stockShortTimeframe = '5';
    }
    if (!validTimeframes.includes(this.filterOpt.stockLongTimeframe)) {
      this.filterOpt.stockLongTimeframe = '30';
    }
  }

  // 進入畫面後要跑的放這裡
  override async ngAfterViewInit() {
    super.ngAfterViewInit();
    await Promise.allSettled([
      this.refreshScheduleStatus(false),
      this.refreshStockScheduleStatus(false),
      this.doLoadConfigFile(false),
    ]);
  }

  override async beforeQuery(): Promise<boolean> {
    await super.beforeQuery();

    return true;
  }

  async doStartSchedule(): Promise<void> {
    this.isBusy = true;
    const body = {
      symbolList: this.filterOpt.symbolList,
      session: this.filterOpt.session,
      shortTimeframe: this.filterOpt.shortTimeframe,
      longTimeframe: this.filterOpt.longTimeframe,
      shortIntervalSeconds: Number(this.filterOpt.shortIntervalSeconds || 300),
      longIntervalSeconds: Number(this.filterOpt.longIntervalSeconds || 1800),
      runImmediately: this.filterOpt.runImmediately,
      monitorConfigPath: './config/esun-monitor.toml',
    };
    try {
      const ret = await this.stockSrv.startFutOptMonitorSchedule(body);
      this.handleRet(ret, '啟動期貨監控排程');
      if (ret.result) {
        this.scheduleStatus = ret.obj || {};
        this.updateScheduleStatusText();
      }
    } finally {
      this.isBusy = false;
      this.cdr.markForCheck();
    }
  }

  async doStopSchedule(): Promise<void> {
    this.isBusy = true;
    try {
      const ret = await this.stockSrv.stopFutOptMonitorSchedule();
      this.handleRet(ret, '停止期貨監控排程');
      if (ret.result) {
        this.scheduleStatus = ret.obj || {};
        this.updateScheduleStatusText();
      }
    } finally {
      this.isBusy = false;
      this.cdr.markForCheck();
    }
  }

  async refreshScheduleStatus(showSuccess: boolean = true): Promise<void> {
    const ret = await this.stockSrv.getFutOptMonitorScheduleStatus();
    if (ret.result) {
      this.scheduleStatus = ret.obj || {};
      this.updateScheduleStatusText();
      if (showSuccess) {
        this.showToast('排程狀態已更新');
      }
    } else if (showSuccess) {
      await this.showAlert('查詢排程狀態失敗:' + this.getRetError(ret));
    }
    this.cdr.markForCheck();
  }

  async doStartStockSchedule(): Promise<void> {
    this.isBusy = true;
    const body = {
      symbolList: this.filterOpt.stockSymbolList,
      shortTimeframe: this.filterOpt.stockShortTimeframe,
      longTimeframe: this.filterOpt.stockLongTimeframe,
      shortIntervalSeconds: Number(this.filterOpt.stockShortIntervalSeconds || 300),
      longIntervalSeconds: Number(this.filterOpt.stockLongIntervalSeconds || 1800),
      runImmediately: this.filterOpt.stockRunImmediately,
      monitorConfigPath: './config/esun-monitor.toml',
    };
    try {
      const ret = await this.stockSrv.startStockMonitorSchedule(body);
      this.handleRet(ret, '啟動股票監控排程');
      if (ret.result) {
        this.stockScheduleStatus = ret.obj || {};
        this.updateStockScheduleStatusText();
      }
    } finally {
      this.isBusy = false;
      this.cdr.markForCheck();
    }
  }

  async doStopStockSchedule(): Promise<void> {
    this.isBusy = true;
    try {
      const ret = await this.stockSrv.stopStockMonitorSchedule();
      this.handleRet(ret, '停止股票監控排程');
      if (ret.result) {
        this.stockScheduleStatus = ret.obj || {};
        this.updateStockScheduleStatusText();
      }
    } finally {
      this.isBusy = false;
      this.cdr.markForCheck();
    }
  }

  async refreshStockScheduleStatus(showSuccess: boolean = true): Promise<void> {
    const ret = await this.stockSrv.getStockMonitorScheduleStatus();
    if (ret.result) {
      this.stockScheduleStatus = ret.obj || {};
      this.updateStockScheduleStatusText();
      if (showSuccess) {
        this.showToast('股票排程狀態已更新');
      }
    } else if (showSuccess) {
      await this.showAlert('查詢股票排程狀態失敗:' + this.getRetError(ret));
    }
    this.cdr.markForCheck();
  }

  async doLoadConfigFile(showSuccess: boolean = true): Promise<void> {
    const ret = await this.stockSrv.getESunConfigFile(this.selectedConfigFile);
    if (ret.result) {
      this.configText = String(ret.obj?.content || '');
      this.configFilePath = String(ret.obj?.filePath || '');
      if (showSuccess) {
        this.showToast('已讀取 ' + this.selectedConfigFile);
      }
    } else {
      await this.showAlert('讀取設定檔失敗:' + this.getRetError(ret));
    }
    this.cdr.markForCheck();
  }

  async doSaveConfigFile(): Promise<void> {
    const ret = await this.stockSrv.saveESunConfigFile(this.selectedConfigFile, this.configText);
    if (ret.result) {
      this.configFilePath = String(ret.obj?.filePath || '');
      this.showToast('已儲存 ' + this.selectedConfigFile);
    } else {
      await this.showAlert('儲存設定檔失敗:' + this.getRetError(ret));
    }
    this.cdr.markForCheck();
  }

  async onConfigFileChange(fileName: string): Promise<void> {
    this.selectedConfigFile = fileName;
    await this.doLoadConfigFile(false);
  }

  onConfigTextInput(value: string): void {
    this.configText = value;
  }

  onRunImmediatelyChange(checked: boolean): void {
    this.filterOpt.runImmediately = checked;
  }

  onStockRunImmediatelyChange(checked: boolean): void {
    this.filterOpt.stockRunImmediately = checked;
  }

  onTickerTypeChange(type: string): void {
    this.filterOpt.tickerType = type;
    if (this.isFutureTickerType()) {
      this.filterOpt.tickerExchange = 'TAIFEX';
      this.filterOpt.tickerMarket = '';
      this.filterOpt.tickerIndustry = '';
      this.filterOpt.tickerIsNormal = '';
      this.filterOpt.tickerIsAttention = '';
      this.filterOpt.tickerIsDisposition = '';
      this.filterOpt.tickerIsHalted = '';
    } else if (this.filterOpt.tickerExchange === 'TAIFEX') {
      this.filterOpt.tickerExchange = '';
    }
  }

  isFutureTickerType(): boolean {
    return this.filterOpt.tickerType === 'FUTURE';
  }

  afterTickerGridReady($event: JkgridwinComponent): void {
    this.tickerGrid = $event;
    this.applyTickerGridData();
  }

  async getTickers(): Promise<void> {
    this.isBusy = true;
    try {
      const ret = await this.stockSrv.getIntradayTickers(this.buildTickerQuery());
      this.apiMessage = JSON.stringify(ret, null, 2);
      if (ret.result) {
        this.tickerList = this.createTickerList(ret.obj);
        this.tickerStatusText = `查詢完成，共 ${ret.obj?.totalRecords ?? this.tickerList.length} 筆`;
        this.applyTickerGridData();
        this.showToast(this.tickerStatusText);
      } else {
        this.tickerList = [];
        this.tickerStatusText = '查詢失敗';
        this.applyTickerGridData();
        await this.showAlert('取得商品資料失敗:' + this.getRetError(ret));
      }
    } catch (error) {
      const errorMessage = this.getRequestErrorMessage(error);
      this.tickerList = [];
      this.tickerStatusText = '查詢失敗';
      this.apiMessage = JSON.stringify({
        result: false,
        message: errorMessage,
        error: this.toSerializableError(error),
      }, null, 2);
      this.applyTickerGridData();
      await this.showAlert('取得商品資料失敗:' + errorMessage);
    } finally {
      this.isBusy = false;
      this.cdr.markForCheck();
    }
  }

  private handleRet(ret: jkRestReturn, caption: string): void {
    this.apiMessage = JSON.stringify(ret, null, 2);
    if (ret.result) {
      this.showToast(caption + '成功');
    } else {
      this.showAlert(caption + '失敗:' + this.getRetError(ret));
    }
  }

  private updateScheduleStatusText(): void {
    this.scheduleStatusText = JSON.stringify(this.scheduleStatus || {}, null, 2);
  }

  private updateStockScheduleStatusText(): void {
    this.stockScheduleStatusText = JSON.stringify(this.stockScheduleStatus || {}, null, 2);
  }

  private getRetError(ret: jkRestReturn): string {
    const getter = (ret as any).getResultError;
    if (typeof getter === 'function') {
      return getter.call(ret);
    }
    return ret.message || ret.errorLog || '後端未回傳錯誤訊息';
  }

  private getRequestErrorMessage(error: unknown): string {
    const err = error as any;
    const status = err?.response?.status;
    const statusText = err?.response?.statusText;
    const dataMessage = this.getResponseDataMessage(err?.response?.data);
    const message = err?.message ? String(err.message) : '';
    const code = err?.code ? String(err.code) : '';

    if (status) {
      const statusMsg = `HTTP ${status}${statusText ? ' ' + statusText : ''}`;
      return dataMessage ? `${statusMsg}: ${dataMessage}` : `${statusMsg}${message ? ': ' + message : ''}`;
    }

    if (message) {
      return code ? `${message} (${code})` : message;
    }

    return String(error || '後端連線失敗');
  }

  private getResponseDataMessage(data: unknown): string {
    if (!data) {
      return '';
    }

    if (typeof data === 'string') {
      return data;
    }

    const obj = data as any;
    const getter = obj?.getResultError;
    if (typeof getter === 'function') {
      return getter.call(obj);
    }

    return obj?.message || obj?.errorLog || JSON.stringify(data);
  }

  private toSerializableError(error: unknown): any {
    const err = error as any;
    if (!err || typeof err !== 'object') {
      return error;
    }

    return {
      name: err.name,
      message: err.message,
      code: err.code,
      status: err.response?.status,
      statusText: err.response?.statusText,
      url: err.config?.url,
      responseData: err.response?.data,
    };
  }

  private buildTickerQuery(): ESunIntradayTickersQuery {
    const query: ESunIntradayTickersQuery = {
      type: this.filterOpt.tickerType,
    };

    if (this.isFutureTickerType()) {
      query.exchange = 'TAIFEX';
      this.assignTickerQueryString(query, 'session', this.filterOpt.tickerSession);
      this.assignTickerQueryString(query, 'product', this.filterOpt.tickerProduct);
      this.assignTickerQueryString(query, 'contractType', this.filterOpt.tickerContractType);
      return query;
    }

    this.assignTickerQueryString(query, 'exchange', this.filterOpt.tickerExchange);
    this.assignTickerQueryString(query, 'market', this.filterOpt.tickerMarket);
    this.assignTickerQueryString(query, 'industry', this.filterOpt.tickerIndustry);
    this.assignTickerQueryBoolean(query, 'isNormal', this.filterOpt.tickerIsNormal);
    this.assignTickerQueryBoolean(query, 'isAttention', this.filterOpt.tickerIsAttention);
    this.assignTickerQueryBoolean(query, 'isDisposition', this.filterOpt.tickerIsDisposition);
    this.assignTickerQueryBoolean(query, 'isHalted', this.filterOpt.tickerIsHalted);
    return query;
  }

  private createTickerList(obj: any): any[] {
    const data = Array.isArray(obj?.data) ? obj.data : [];
    return data.map((item: any) => ({
      ...item,
      date: obj?.date || '',
      type: obj?.type || '',
      exchange: obj?.exchange || '',
      market: obj?.market || '',
      industry: obj?.industry || '',
      session: obj?.session || '',
      product: obj?.product || '',
      contractType: item.contractType || obj?.contractType || '',
      referencePrice: item.referencePrice,
      isDynamicBanding: item.isDynamicBanding,
      flowGroup: item.flowGroup,
      startDate: item.startDate || '',
      endDate: item.endDate || '',
      settlementDate: item.settlementDate || '',
      isNormal: obj?.isNormal,
      isAttention: obj?.isAttention,
      isDisposition: obj?.isDisposition,
      isHalted: obj?.isHalted,
    }));
  }

  private assignTickerQueryString(
    query: ESunIntradayTickersQuery,
    key: keyof Pick<ESunIntradayTickersQuery, 'exchange' | 'market' | 'industry' | 'session' | 'product' | 'contractType'>,
    value: string
  ): void {
    const text = String(value || '').trim();
    if (text !== '') {
      query[key] = text;
    }
  }

  private assignTickerQueryBoolean(
    query: ESunIntradayTickersQuery,
    key: keyof Pick<ESunIntradayTickersQuery, 'isNormal' | 'isAttention' | 'isDisposition' | 'isHalted'>,
    value: string
  ): void {
    if (value === 'true') {
      query[key] = true;
    } else if (value === 'false') {
      query[key] = false;
    }
  }

  private applyTickerGridData(): void {
    if (!this.tickerGrid) {
      return;
    }
    this.tickerGrid.columnDefs = this.tickerColumnDefs;
    this.tickerGrid.updateColumnsCount();
    this.tickerGrid.setItemList(this.tickerList);
    const gridApi = this.tickerGrid.gridSrv?.gridApi;
    if (gridApi) {
      gridApi.setGridOption('columnDefs', this.tickerColumnDefs);
      gridApi.setGridOption('rowData', this.tickerList);
      gridApi.sizeColumnsToFit();
    }
  }
}
